<template>
    <div class="inner-container">
        <div class="table-container">
            <b-table
                :fields="tableFields"
                :items="goodsData"
                responsive="true"
                bordered
                head-variant="light"
                sticky-header="true"
                no-border-collapse
            >
                <template #head(more)>
                    <div class="text-center">
                        <i
                            :title="getCommonText('del_selected')"
                            class="icon icon-close table-all-remove"
                            @click="
                                deleteItem(
                                    `${
                                        selectAllGoods
                                            ? getDecText('del_all_recs')
                                            : getDecText('del_selected_recs')
                                    }`
                                )
                            "
                        />
                    </div>
                </template>
                <template #top-row="data">
                    <td></td>
                    <td></td>
                    <td
                        colspan="3"
                        class="td-numbering table-success text-center"
                    >
                        1
                    </td>
                    <td class="td-numbering table-danger text-center">2</td>
                    <td class="td-numbering table-info text-center">3</td>
                    <td class="td-numbering table-primary text-center">4</td>
                    <td class="td-numbering table-warning text-center">5</td>
                    <td class="td-numbering table-success text-center">6</td>
                    <td class="td-numbering table-danger text-center">7</td>
                    <td class="td-numbering text-center"></td>
                </template>
                <template #head(action)>
                    <div class="text-center">
                        <b-form-checkbox
                            v-model="selectAllGoods"
                            @change="
                                (e) => $emit('setIsAllDelete', e, goodsData)
                            "
                            :value="true"
                            :unchecked-value="false"
                        />
                    </div>
                </template>
                <template #cell(action)="data">
                    <b-form-checkbox
                        v-model="data.item.itemToDelete"
                        @input="
                            (e) => {
                                if (!e) selectAllGoods = false;
                            }
                        "
                        :value="true"
                        :unchecked-value="false"
                    />
                </template>
                <template #cell(good_name)="data">
                    <div class="form-03149-multiselect-group error">
                        <multiselect
                            v-b-popover.hover.topright="
                                currDecodeName ? currDecodeName.name : null
                            "
                            v-if="variantAttribute && data.item.isNew"
                            v-model="currDecodeName"
                            style="width: 270px"
                            label="name"
                            :placeholder="getDecText('enter_name')"
                            :options="ensTruNamePrt"
                            :searchable="true"
                            :allow-empty="false"
                            :show-labels="false"
                            :internal-search="false"
                            @blur="() => ensTruNamePrt.splice(0)"
                            @search-change="(e) => $emit('searchName', e)"
                            @input="setCurrGoodDesc(data.item)"
                        >
                            <span slot="noResult">
                                {{ getDecText("name_not_found") }}
                            </span>
                            <span slot="noOptions">
                                {{ getDecText("start_typing_name") }}
                            </span>
                        </multiselect>
                        <div
                            v-else
                            :id="`ens-item-name-${data.item.id}`"
                            v-bind:class="{
                                'ens-item-non-active': !data.item.esnActive,
                            }"
                        >
                            {{ data.item.name }}
                        </div>
                        <b-spinner
                            v-if="data.item.isNew && parNameLoading"
                            small
                            label="Small Spinner"
                        ></b-spinner>
                        <b-popover
                            v-if="!data.item.esnActive"
                            placement="topright"
                            :target="`ens-item-name-${data.item.id}`"
                            triggers="hover focus"
                        >
                            {{ getDecText("code_isnt_active") }}
                        </b-popover>

                        <template v-if="data.item.isHasDouble">
                            <i class="icon icon-danger decodes-error-icon"></i>
                            <div class="pop-up">
                                <p class="red-text">
                                    {{ getCommonText("not_valid") }}
                                </p>
                                <p>{{ getCommonText("exist") }}</p>
                            </div>
                        </template>
                    </div>
                </template>
                <template #cell(shrt_descr)="data">
                    <b-spinner
                        class="form-03149-spinner"
                        v-if="data.item.isNew && descIsLoading"
                        small
                        label="Small Spinner"
                    ></b-spinner>
                    <multiselect
                        v-b-popover.hover.topright="
                            data.item.currGoodDesc
                                ? data.item.currGoodDesc.detail
                                : null
                        "
                        v-if="
                            variantAttribute &&
                            data.item.ensTruName &&
                            data.item.ensTruName.length > 1
                        "
                        v-model="data.item.currGoodDesc"
                        style="width: 270px"
                        label="detail"
                        :placeholder="getDecText('select_characteristics')"
                        :options="data.item.ensTruName"
                        :searchable="true"
                        :allow-empty="false"
                        :show-labels="false"
                        @input="descSelectedNameChanged(data.item)"
                    >
                        <span slot="noOptions">
                            {{ getDecText("select_name") }}
                        </span>
                    </multiselect>
                    <div v-else>{{ data.item.shrDescr }}</div>
                </template>
                <template #cell(additional_descr)="data">
                    <b-form-textarea
                        v-if="variantAttribute && data.item.enstru_code"
                        style="min-height: 100px"
                        v-model.trim="data.item.add_detail"
                        @change="onAdditionalDescrChanged(data.item)"
                        :formatter="formatText"
                    ></b-form-textarea>
                    <div v-else>{{ data.item.add_detail }}</div>
                </template>
                <template #cell(inf_sys)="data">
                    <div class="column-width-100 bp-category-name">
                        <div>{{ data.item["inf_sys_" + lng] }}</div>
                        <i
                            v-if="variantAttribute && data.item.enstru_code"
                            class="icon icon-pencil-edit thin-blue ml-3 pointer icon-18"
                            @click="
                                showEditModal(data.item, 'setInfSysDecodeModal')
                            "
                        ></i>
                    </div>
                </template>
                <template #cell(name_prod)="data">
                    <div class="column-width-100 bp-category-name">
                        <div>{{ data.item["name_prod_" + lng] }}</div>
                        <i
                            v-if="variantAttribute && data.item.enstru_code"
                            class="icon icon-pencil-edit thin-blue ml-3 pointer icon-18"
                            @click="
                                showEditModal(
                                    data.item,
                                    'setNameProdDecodeModal'
                                )
                            "
                        ></i>
                    </div>
                </template>

                <template #cell(amount)="data">
                    <b-form-input
                        v-if="variantAttribute && data.item.enstru_code"
                        class="text-right"
                        :value="data.item.amount"
                        @change="(v) => inputFixed(data.item, 'amount', v, 2)"
                        @keyup.enter.exact="keyup13"
                        @keypress="keyPress($event, '^\\d*\\.?\\d{0,9}$')"
                    >
                    </b-form-input>
                    <div v-else class="text-right">{{ $n(data.value) }}</div>
                    <p
                        class="goods-form-val-msg"
                        v-if="
                            variantAttribute &&
                            data.item.enstru_code &&
                            (!data.item.amount || data.item.amount <= 0)
                        "
                    >
                        {{ getCommonText("positive") }}
                    </p>
                </template>
                <template #cell(one_item_cost)="data">
                    <b-form-input
                        v-if="variantAttribute && data.item.enstru_code"
                        class="text-right"
                        :value="data.item.cost"
                        @change="(v) => inputFixed(data.item, 'cost', v, 2)"
                        @keyup.enter.exact="keyup13"
                        @keypress="keyPress($event, '^\\d*\\.?\\d{0,9}$')"
                    >
                    </b-form-input>
                    <div v-else class="text-right">{{ $n(data.value) }}</div>
                    <p
                        class="goods-form-val-msg"
                        v-if="
                            variantAttribute &&
                            data.item.enstru_code &&
                            (!data.item.cost || data.item.cost <= 0)
                        "
                    >
                        {{ getCommonText("positive") }}
                    </p>
                </template>

                <template #cell(total)="data">
                    <div class="text-right">
                        {{ $n(calcRowTotal(data.item)) }}
                    </div>
                </template>

                <template #cell(files)="data">
                    <span
                        class="blue pointer underline"
                        @click="onFilesClick(data.item)"
                        >({{
                            data.item.file_hash
                                ? data.item.file_hash.split(";").length
                                : 0
                        }})</span
                    >
                </template>
                <template #cell(more)="data">
                    <i
                        class="icon icon-clear table-remove"
                        :disabled="goodsAreSaving"
                        v-if="variantAttribute"
                        @click="
                            deleteItem(
                                `${getDecText('del_curr_rec')}`,
                                data.item,
                                data.index
                            )
                        "
                    ></i>
                </template>

                <template #bottom-row="data">
                    <td class="text-left" colspan="3">
                        {{ getCommonText("total") }}
                    </td>
                    <td class="text-center">x</td>
                    <td class="text-center">x</td>
                    <td class="text-center">x</td>
                    <td class="text-center">x</td>
                    <td class="text-right">{{ $n(totalAmount) }}</td>
                    <td class="text-right">{{ $n(totalCost) }}</td>
                    <td class="text-right">{{ $n(goodsTotal) }}</td>
                    <td colspan="2"></td>
                </template>
            </b-table>

            <modal-files-management
                ref="modalFilesManagement"
                :allFiles="allFiles"
                :variantAttribute="variantAttribute"
                @showFileUploadModal="showFileUploadModal"
                @setNewFileHash="setNewFileHash"
                @triggDownloadFile="triggDownloadFile"
                @triggDownloadAllFiles="triggDownloadAllFiles"
            ></modal-files-management>

            <c-set-b-f-category-name
                ref="setInfSysDecodeModal"
                :budgetForm="goodsData"
                :lng="lng"
                :getCommonText="getCommonText"
                :categoryFieldNames="{ ru: 'inf_sys_ru', kk: 'inf_sys_kk' }"
                :maxNameLengthSymbls="255"
                :title="this.getFormText('inf_sys')"
                :textareaTitleRu="this.getFormText('inf_sys_textarea_title_ru')"
                :textareaTitleKk="this.getFormText('inf_sys_textarea_title_kk')"
                :placeHolder="this.getFormText('inf_sys_placeholder')"
                :canBeEmpty="true"
                :isDoublesCheckNeeded="false"
                @saveItem="onDataChanged"
            />
            <c-set-b-f-category-name
                ref="setNameProdDecodeModal"
                :budgetForm="goodsData"
                :lng="lng"
                :getCommonText="getCommonText"
                :categoryFieldNames="{ ru: 'name_prod_ru', kk: 'name_prod_kk' }"
                :maxNameLengthSymbls="255"
                :title="this.getFormText('name_prod')"
                :textareaTitleRu="
                    this.getFormText('name_prod_textarea_title_ru')
                "
                :textareaTitleKk="
                    this.getFormText('name_prod_textarea_title_kk')
                "
                :placeHolder="this.getFormText('name_prod_placeholder')"
                :canBeEmpty="true"
                :isDoublesCheckNeeded="false"
                @saveItem="onDataChanged"
            />
        </div>
    </div>
</template>

<script>
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import ModalFilesManagement from "./modal-files-management.vue";
import BpI18nHandlerMixin from "../mixins/bp-i18n-handler-mixin";
import CSetBFCategoryName from "@/modules/budget-request/components/c-set-bf-category-name.vue";

// ###################################################################################

//  используется в форме 01-158

// ###################################################################################

export default {
    name: "FormTemplate11",
    components: { ModalFilesManagement, CSetBFCategoryName },
    mixins: [BpI18nHandlerMixin],
    props: {
        goodsData: Array,
        ensTruDict: Array,
        variantAttribute: Boolean,
        currCategory: Object,
        lng: String,
        lang: String,
        deleteGood: Function,
        ifAllFieldsFilled: Function,
        ensTruNamePrt: Array,
        ensTruName: Array,
        loadCurUnits: Function,
        getEnstruByName: Function,
        showFileUploadModal: Function,
        triggDownloadFile: Function,
        triggDownloadAllFiles: Function,
        parNameLoading: Boolean,
        descIsLoading: Boolean,
        allFiles: Array,
        goodsAreSaving: Boolean,
        isDoubleDecodeExist: Function,
        safeDecimal: Function,
    },

    data() {
        return {
            dataTypeFilter: null,
            variantName: null,
            formFilter: null,
            budgetForm: [],
            header: null,
            dict: [],
            files: null,
            load: false,
            openDisabled: false,
            isLoad: false,
            currUnit: null,
            currDecodeName: null,
            totalPrice: 0,
            currGoodDesc: null,
            totalAvgPrice: 0,
            totalCostsM: 0,
            totalCostsArea: 0,
            megaTotalSaved: 0,
            megaTotal: 0,
            selectAllGoods: false,
            isHasDouble: false,
        };
    },

    methods: {
        addItem() {
            if (this.isDoubleDecodeExist()) return;
            if (!this.isLastRecordValid()) return;

            // проверяем все ли поля заполнены
            this.currDecodeName = null;
            const item = { id: new Date() * -1 };
            this.$set(item, "order_number", this.goodsData.length + 1);
            this.$set(item, "enstru_code", null);
            this.$set(item, "add_detail", null);
            this.$set(item, "inf_sys_ru", null);
            this.$set(item, "inf_sys_kk", null);
            this.$set(item, "name_prod_ru", null);
            this.$set(item, "name_prod_kk", null);
            this.$set(item, "amount", null);
            this.$set(item, "cost", null);
            this.$set(item, "isNew", true);
            this.$set(item, "rowToSave", true);
            this.$set(item, "ensTruPassVal", false);
            this.$set(item, "descrPassVal", false);
            this.$set(item, "amountPassVal", false);
            this.$set(item, "costPassVal", false);
            this.$set(item, "currGoodDesc", null);
            this.$set(item, "esnActive", true);
            this.$set(item, "itemToDelete", false);
            this.$set(item, "file_hash", null);
            this.$set(item, "category_id", this.currCategory.category_id);
            this.goodsData.push(item);
            this.ensTruDict.splice(0);
        }, // добавление записи в таблицу

        isLastRecordValid() {
            if (this.goodsData.length) {
                const lastItem = this.goodsData.at(-1);
                this.decodeDataValidation(lastItem);
                if (!this.ifAllFieldsFilled()) return false;
                this.$set(lastItem, "isNew", false);
            }
            return true;
        }, // проверка последней записи на заполненность полей

        calcRowTotal(item) {
            let total = 0;
            if (item.amount && item.cost) {
                const amount = this.safeDecimal(item.amount).toDecimalPlaces(2);
                const oneItemCost = this.safeDecimal(item.cost).toDecimalPlaces(
                    2
                );
                total = amount
                    .mul(oneItemCost)
                    .div(1000)
                    .toDecimalPlaces(3)
                    .toNumber();
            }
            this.$set(item, "total", total);
            return total;
        },
        async setCurrGoodDesc(item) {
            await this.getEnstruByName(this.currDecodeName.name);
            process.nextTick(() => {
                if (this.ensTruName.length) {
                    const relativeDecrIdx = this.ensTruName.findIndex(
                        (itm) => itm.code === this.currDecodeName.code
                    );
                    this.$set(
                        item,
                        "currGoodDesc",
                        this.ensTruName[
                            relativeDecrIdx !== -1 ? relativeDecrIdx : 0
                        ]
                    );
                    this.$set(item, "ensTruName", this.ensTruName);
                    this.descSelectedNameChanged(item);
                }
            });
        },

        makeToast(variant = null, title, msg) {
            this.$bvToast.toast(msg, {
                title: title,
                variant: variant,
                solid: true,
            });
        },

        async descSelectedNameChanged(item) {
            process.nextTick(() => {
                this.$set(item, "enstru_code", item.currGoodDesc.code);
                this.$set(
                    item,
                    "shrDescr",
                    item.currGoodDesc["detail_" + this.lang] + ' (' + item.currGoodDesc.code + ')'
                );
                this.$set(item, "name", item.currGoodDesc["name_" + this.lang]);
                this.onDataChanged(item);
                this.doublesValidationDecodes();
            });
        },

        doublesValidationDecodes() {
            const doublesMap = {};
            this.$nextTick(() => {
                this.goodsData.forEach(item => {
                    const addDetailTrimmed = item.add_detail ? item.add_detail.trim().toLowerCase() : '';
                    const enstruCode = item.enstru_code;
                    if (!!enstruCode) {
                        const mapKey = `${enstruCode}_${addDetailTrimmed}`;
                        if (doublesMap[mapKey]) {
                            doublesMap[mapKey].push(item.id);   
                        } else {
                            doublesMap[mapKey] = [item.id];
                        }
                    }
                })
                const doubleIdsList = [];
                for (const key in doublesMap) {
                    const idsList = doublesMap[key];
                    const isKeyHasDoubles = idsList.length > 1;
                    if (isKeyHasDoubles) {
                        doubleIdsList.push(...idsList);
                    }
                }

                if (doubleIdsList.length > 0) {
                    this.goodsData.forEach((item) => {
                        if (doubleIdsList.includes(item.id)) {
                            this.$set(item, "isHasDouble", true);
                        } else {
                            this.$set(item, "isHasDouble", false);
                        }
                    });
                } else
                    this.goodsData.forEach((item) =>
                        this.$set(item, "isHasDouble", false)
                    );
            });
        },

        formatText(text) {
            if (text.length > 254) {
                return text.slice(0, 254);
            } else {
                return text;
            }
        },

        inputFixed(item, field, value, digit) {
            // nextTick добавлен тк не без него не работает реактивность при событии keyPress.enter если предыдущее значение = 0
            this.$nextTick(() => {
                let newVal = this.safeDecimal(value)
                    .toDecimalPlaces(digit)
                    .toNumber();
                if (newVal !== item[field]) {
                    if (newVal < 0) newVal = newVal * -1;
                    this.$set(item, field, newVal);
                    this.onDataChanged(item);
                }
            });
        }, // форматирует введенное значение до digit цифр после запятой

        onDataChanged(item) {
            this.$set(item, "rowToSave", true);
            this.$emit("setDataChanged", true);
            this.decodeDataValidation(item);
        }, // переключения тригера при изменении данных товаров

        decodeDataValidation(item) {
            if (!item.enstru_code) {
                this.$set(item, "ensTruPassVal", false);
            } else this.$set(item, "ensTruPassVal", true);

            if (!item.shrDescr) {
                this.$set(item, "descrPassVal", false);
            } else this.$set(item, "descrPassVal", true);

            if (!item.amount || item.amount <= 0) {
                this.$set(item, "amountPassVal", false);
            } else this.$set(item, "amountPassVal", true);

            if (!item.cost || item.cost <= 0) {
                this.$set(item, "costPassVal", false);
            } else this.$set(item, "costPassVal", true);
        },

        keyPress: function (event, pattern) {
            const regex = new RegExp(pattern);
            const key = String.fromCharCode(
                !event.charCode ? event.which : event.charCode
            );
            if (!regex.test(key)) {
                event.preventDefault();
                return false;
            }
        }, // вводит по заданному паттерну

        keyup13: function (event) {
            event.preventDefault();
            // Isolate the node that we're after
            const currentNode = event.target;
            // find all tab-able elements
            const allElements = document.querySelectorAll("input"); // area, object, select, [contenteditable]
            // Find the current tab index.
            const currentIndex = [...allElements].findIndex((el) =>
                currentNode.isEqualNode(el)
            );
            // select/focus the following element
            const targetIndex = (currentIndex + 1) % allElements.length;
            if (targetIndex < allElements.length) {
                allElements[targetIndex].select();
            }
        }, // enter работает как tab

        deleteItem(msg, row = false, index = false) {
            if (
                !this.variantAttribute ||
                (!row &&
                    this.goodsData.findIndex((itm) => itm.itemToDelete) === -1)
            )
                return;
            let deletingRow = null;
            this.$bvModal
                .msgBoxConfirm(`${msg}...`, {
                    title: this.getCommonText("confirm"),
                    size: "lg",
                    buttonSize: "sm",
                    okVariant: "danger",
                    okTitle: this.getCommonText("yes"),
                    cancelTitle: this.getCommonText("cancel"),
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        if (row) {
                            if ((!row.id || row.id < 0) && row.rowToSave) {
                                this.goodsData.splice(index, 1);
                                this.$emit("doublesValidationDecodes");
                            } else {
                                this.$emit("deleteRows", [row], "decodes");
                                deletingRow = this.goodsData.splice(index, 1);
                            }
                        } else {
                            const existingRowsToDel = [];
                            for (
                                let i = this.goodsData.length - 1;
                                i >= 0;
                                i--
                            ) {
                                if (this.goodsData[i].itemToDelete) {
                                    const rowId = this.goodsData[i].id;
                                    if (rowId >= 0) {
                                        existingRowsToDel.push(
                                            this.goodsData[i]
                                        );
                                    }
                                    this.goodsData.splice(i, 1);
                                }
                            }
                            if (existingRowsToDel.length) {
                                this.$emit(
                                    "deleteRows",
                                    existingRowsToDel,
                                    "decodes"
                                );
                            }
                            this.selectAllGoods = false;
                        }
                    }
                })
                .catch((error) => {
                    if (deletingRow)
                        this.goodsData = [
                            ...this.goodsData,
                            ...deletingRow,
                        ].sort((a, b) => a.id - b.id);
                    this.makeToast(
                        "danger",
                        this.getErrText("on_del"),
                        error.toString()
                    );
                });
        }, // удаление записи

        onFilesClick(item) {
            this.$refs.modalFilesManagement.showModal(item);
        },

        setNewFileHash(id, codes) {
            for (const good of this.goodsData) {
                if (good.id === id) {
                    this.$set(good, "file_hash", codes);
                    this.onDataChanged(good);
                    break;
                }
            }
        },

        roundNumber(input, decimalPlaces) {
            const numberValue = Number(input) || 0;
            const decimalPlacesValue = Number(decimalPlaces) || 0;
            const rank = Math.pow(10, decimalPlacesValue);
            const mult = Math.round(numberValue * rank * 100) / 100;
            const roundedNumber = Math.round(mult) / rank;
            return roundedNumber;
        },

        onAdditionalDescrChanged(item) {
            this.onDataChanged(item);
            this.doublesValidationDecodes();
        },

        showEditModal(row, modalRef) {
            if (!row.enstru_code) return;

            const modal = this.$refs[modalRef];
            if (modal) modal.showModal(row);
        },
    },

    computed: {
        goodsTotal() {
            let sum = 0;
            for (const row of this.goodsData) {
                sum += parseFloat(row.total);
            }
            return sum;
        },

        totalAmount() {
            let sum = 0;
            for (const row of this.goodsData) {
                if (!row.amount) continue;
                sum += parseFloat(row.amount);
            }
            return sum;
        },

        totalCost() {
            let sum = 0;
            if (!this.totalAmount) return sum;
            sum = (this.goodsTotal * 1000) / this.totalAmount;
            return this.safeDecimal(sum).toDecimalPlaces(2).toNumber();
        },

        getFormText() {
            return this.setFormText("form_01_158.");
        },

        tableFields() {
            if (this.$i18n.locale) {
                return [
                    {
                        key: "action",
                        label: " ",
                    },
                    {
                        key: "order_number",
                        label: this.getCommonText("sn"),
                    },
                    {
                        key: "good_name",
                        label: this.getCommonText("name"),
                    },
                    {
                        key: "shrt_descr",
                        label: this.getCommonText("short_info"),
                    },
                    {
                        key: "additional_descr",
                        label: this.getCommonText("add_info"),
                    },
                    {
                        key: "inf_sys",
                        label: this.getFormText("inf_sys"),
                    },
                    {
                        key: "name_prod",
                        label: this.getFormText("name_prod"),
                    },
                    {
                        key: "amount",
                        label: this.getFormText("amount"),
                    },
                    {
                        key: "one_item_cost",
                        label: this.getFormText("one_item_cost"),
                    },
                    {
                        key: "total",
                        label: this.getFormText("total_decode"),
                    },
                    {
                        key: "files",
                        label: this.getCommonText("files"),
                    },
                    {
                        key: "more",
                        label: "",
                    },
                ];
            }
            return [];
        },
    },
};
</script>

<style scoped>
.form-03149-multiselect-group {
    display: flex;
}

.form-03149-multiselect-group .spinner-border {
    position: relative;
    right: 50px;
    opacity: 0.3;
    margin: auto;
    color: #7a87a0;
    z-index: 999;
}

.form-03149-spinner {
    display: block;
    margin: auto;
    color: #7a87a0;
}

.goods-form-val-msg {
    font-size: 0.5rem;
    font-style: italic;
    color: red;
}

.ens-item-non-active {
    color: #6087a099;
}

.decodes-error-icon {
    top: -20px;
    left: 0px;
}
</style>
